module.exports = __webpack_public_path__ + "img/dashboard_new_repair.ca309f5.png";